import {
    axios
} from '@/utils/request'

// 友情链接
export function listPatent(parameter) {
    return axios({
        url: '/link/tbLink/notPageList',
        method: 'get',
        params: parameter
    })
}

// 菜单
export function listMenu(parameter) {
    return axios({
        url: '/home/tbColumn/treeTbColumnListOnlyNew',
        method: 'get',
        params: parameter
    })
}

// 获取新闻列表
export function getAllNewsList(parameter) {
    return axios({
        url: '/home/tbHomeNews/list',
        method: 'get',
        params: parameter
    })
}

// 根据类型查询新闻分页
export function getNewsTypeList(parameter) {
    return axios({
        url: '/home/tbHomeNews/queryNewsByType?column=createTime&order=desc',
        method: 'get',
        params: parameter
    })
}

// 根据类型查询新闻详情
export function getNewsDetail(parameter) {
    return axios({
        url: '/home/tbHomeNews/queryById',
        method: 'get',
        params: parameter
    })
}

// 新闻详情-上下条
export function getNewsFootById(parameter) {
    return axios({
        url: '/home/tbHomeNews/getFootById',
        method: 'get',
        params: parameter
    })
}


// 全局搜索
export function allsearch(parameter) {
    return axios({
        url: '/home/tbHomeNews/public/findArticleByKeyword',
        method: 'get',
        params: parameter
    })
}